import { useQuery } from 'react-query'
import { getActiveUsers, getForemen, getUsers } from './userApi'

export const useUsers = ({ enabled }: { enabled: boolean }) => {
  return useQuery(['users'], getUsers, { enabled })
}

export const useActiveUsers = () => {
  return useQuery(['users', 'active'], getActiveUsers)
}

export const useForemen = () => {
  return useQuery(['users', 'foremen'], getForemen)
}